import * as API from '@/endpoints'
import Axios from 'axios'
import _ from 'lodash'
import {Message} from 'iview'
// import { resolveMx } from 'dns';

export default {
  namespaced: true,
  state: {
    data: {
      activity: {
        careplan_item: []
      },
      isLoading: false
    }
  },
  mutations: {
    setGalleryLoader(state, v) {
      state.data.isLoading = v
    },
    setGalleryData(state, v) {
      state.data.activity = v
      // due to a bug on total. since the api will return 3 items only due to per_page parameter
      state.data.activity.total = state.data.activity.careplan_item.length
    },
    setGalleryItemData(state, payload) {
      let newArray = state.data.activity.careplan_item.slice();
      for(let i = 0; i < newArray.length; i++) {
        if (newArray[i].id == payload.id) {
          console.log(newArray[i].cover_photo, payload.cover_photo)
          newArray[i] = { ...payload }
          console.log('updated')
        }
      }

      state.data.activity.careplan_item = newArray;
    },
    addNewActivity(state, v) {
      state.data.activity.careplan_item.push(v)
      state.data.activity.total += 1;
    },
    removeActivity(state, v) {
      for( let x = 0; x < state.data.activity.careplan_item.length; x++ ) {
        if(state.data.activity.careplan_item && v.id == state.data.activity.careplan_item[x].id) {
          state.data.activity.careplan_item.splice(x, 1)
          state.data.activity.total -= 1;
          Message.success('Image deleted successfully');
        }
      }
    }
  },
  actions: {
    checkGallery({dispatch, state}, {id}) {
      if ( !id ) return false;
      return new Promise( (resolve, reject) => {
        for( let x = 0; x < state.data.activity.careplan_item.length; x++ ) {
          if ('isDeleted' in state.data.activity.careplan_item[x] ) {
            // TODO DELETE ITEM
            let itemIndex = _.clone(x), activity = _.cloneDeep(state.data.activity.careplan_item[itemIndex])
            Axios.delete(API.endpoints.base + "careplan/" + id + '/item/' + activity.id).then(
              res => {
                state.data.activity.careplan_item.splice(itemIndex, 1)
              }, error => {
                dispatch("exceptionHandling", { _err: error }, { root: 1 });
              });
            continue;
          }
          if ('status' in state.data.activity.careplan_item[x] && state.data.activity.careplan_item[x].status == 'updated') {
            // TODO UPDATE ITEM
            let itemIndex = _.clone(x), activity = _.cloneDeep(state.data.activity.careplan_item[itemIndex])
            Axios.put(API.endpoints.base + "careplan/" + id + '/item/' + activity.id, activity).then(
              res => {
                delete state.data.activity.careplan_item[itemIndex].status
                state.data.activity.careplan_item[itemIndex].cover_photo = res.data.cover_photo
                state.data.activity.careplan_item[itemIndex].cover_photo_uri = res.data.cover_photo_uri
              }, error => {
                dispatch("exceptionHandling", { _err: error }, { root: 1 });
              });
            continue;
          }
          if ('guid' in state.data.activity.careplan_item[x] && state.data.activity.careplan_item[x].guid) {
            // TODO create ITEM
            let itemIndex = _.clone(x), activity = _.cloneDeep(state.data.activity.careplan_item[itemIndex])
            Axios.post(API.endpoints.base + "careplan/" + id + '/item', activity).then(
              res => {
                delete state.data.activity.careplan_item[itemIndex].guid
                state.data.activity.careplan_item[itemIndex].id = res.data.id
                state.data.activity.careplan_item[itemIndex].cover_photo = res.data.cover_photo
                state.data.activity.careplan_item[itemIndex].cover_photo_uri = res.data.cover_photo_uri
              }, error => {
                dispatch("exceptionHandling", { _err: error }, { root: 1 });
              });
            continue;
          }
        }

        resolve('success')
      })
    },
    setGalleryAvatar({rootState, dispatch}, {act}) {
      return new Promise((resolve, reject) => {
        Axios.post(API.endpoints.base + "image/uploadfromurl", {url: rootState.baseImageUrl + 'original' + act.cover_photo_uri}).then(
          res => {
            resolve(res.data);
          }, error => {
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);activityactivityactivity
          }
        );
      });
    },
    updateGalleryActivity({commit, dispatch}, {id, data}) {
      return new Promise((resolve, reject) => {
        if ( !id ) return false;
        Axios.put(API.endpoints.base + "careplan/" + id + '/item/' + data.id, data).then(
          res => {
            Message.success('Image updated successfully')
            resolve(res.data);
          }, error => {
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          }
        );
      });
    },
    deleteGalleryActivity({commit, dispatch}, {id, data}) {
      return new Promise((resolve, reject) => {
        if ( !id ) return false;
        Axios.delete(API.endpoints.base + "careplan/" + id + '/item/' + data.id).then(
          res => {
            resolve(res.data);
          }, error => {
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          }
        );
      });
    },
    setNewGalleryActivity({commit, dispatch}, {id, data}) {
      return new Promise((resolve, reject) => {
        if ( !id ) return false;
        Axios.post(API.endpoints.base + "careplan/" + id + '/item', data).then(
          res => {
            Message.success('Image uploaded successfully')
            resolve(res.data);
          }, error => {
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          }
        );
      });
    },
    getUserGallery({commit, dispatch}, {id}) {
      return new Promise((resolve, reject) => {
        if ( !id ) return false;

        commit('setGalleryLoader', true);
        Axios.get(API.endpoints.base + "careplan/" + id + '/item?type=gallery&per_page=3').then(
          res => {
            commit('setGalleryData', res.data);
            commit('setGalleryLoader', false);
            resolve(res.data);
          }, error => {
            commit('setGalleryLoader', false);
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          }
        );
      });
    }
  }
}
